// OWNER: Agent C (UI). Foundation left a working shell — replace freely,
// except src/client/routes/login/** and src/client/lib/auth.tsx (Agent A).
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { Toasty } from "@cloudflare/kumo/components/toast";
import { AuthProvider } from "./lib/auth";
import App from "./App";
import "./styles.css";

async function enableMocking() {
  // Agents A/B/D's routes are live on main now. MSW still intercepts every
  // /api/* call by default in dev (realistic fixtures, no backend required),
  // but `npm run dev:worker` + `wrangler dev` on :8787 is a real target too
  // (vite.config.ts already proxies /api there) — set VITE_DISABLE_MOCKS=true
  // in .env.local to talk to it instead of the mocks.
  if (!import.meta.env.DEV || import.meta.env.VITE_DISABLE_MOCKS === "true") return;
  const { worker } = await import("./mocks/browser");
  return worker.start({ onUnhandledRequest: "bypass" });
}

const el = document.getElementById("root");
if (!el) throw new Error("#root missing");

enableMocking().then(() => {
  createRoot(el).render(
    <StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <Toasty>
            <App />
          </Toasty>
        </AuthProvider>
      </BrowserRouter>
    </StrictMode>,
  );
});
